/** This build's version, for error reports. Outside a Vite build (bun test) it reads "dev". */
export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev'
